<template>
  <svg
    width="26"
    height="4"
    viewBox="0 0 26 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.083252 2.00397C0.083252 1.31358 0.642896 0.753906 1.33325 0.753906L24.6666 0.753906C25.3569 0.753906 25.9166 1.31358 25.9166 2.00397C25.9166 2.69436 25.3569 3.25403 24.6666 3.25403L1.33325 3.25403C0.642896 3.25403 0.083252 2.69436 0.083252 2.00397Z"
      fill="#2491E7"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
